export const getCacheSettings = (min = 5) => ({
  keepPreviousData: true,
  staleTime: min * 60 * 1000,
});
